import styled from "styled-components";
import { theme } from "@themes";

export const Page = styled.div`
  font-family: ${({ theme }) => theme.font.primary};
  background: ${({ theme }) => theme.neutral.gray[100]};
  color: ${({ theme }) => theme.neutral.gray[3900]};
  min-height: 100vh;
`;

export const Hero = styled.div`
  width: 100%;
  height: 305px;
  overflow: hidden;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MainSection = styled.section`
  padding: 50px 20px 60px;
  text-align: center;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: auto;
`;

export const LogoImage = styled.img`
  height: 40px;
  margin-bottom: 10px;
`;

export const Subtitle = styled.p`
  max-width: 650px;
  margin: 0 auto 40px;
  color: ${({ theme }) => theme.text.muted};
  line-height: 1.5;
  font-size: 16px;
`;

export const ModulesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 18px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
